import request from '@/utils/request';
export const fileTransferHeaders = {};
export const sendRecoveryMail = data => request({
  url: '/queue/email',
  method: 'post',
  data
});